// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HspV","root_text":"styles_root_text__2sd53","root__isToggled":"styles_root__isToggled__2dn8B","root_icon":"styles_root_icon__3PyTE"};